import React from 'react'
import { Link } from 'react-router-dom'
import { MDBDataTable } from 'mdbreact';
import ExportExcel from './../Tables/ExportExcel';

const data={
    columns: [
      {
        label: 'Fecha',
        field: 'date',
        sort: 'asc',
        width: 150
      },  
        {
          label: 'Medio',
          field: 'media',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Fecha de publicación',
          field: 'publicationDate',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Título',
          field: 'title',
          sort: 'asc',
          width: 150
        },
        {
            label: 'Texto',
            field: 'text',
            sort: 'asc',
            width: 150
          },
        {
          label: 'Imagen',
          field: 'img',
          sort: 'asc',
          width: 150
        },
    ],
    rows:[
    {
        id: 1,
        date:"2/4/23",
        media: "Tiempo de seguros",
        publicationDate: "Octubre 2022",
        title: "2022-2023 en Seguros de Caución, ¿Avance, Arrastre o Recesión?",
        text: "Arrancó el ejercicio 2022-2023 en el nicho de las fianzas argentinas, con estimaciones que nos permiten avizorar que el avance del negocio sigue a buen ritmo, pero a menor velocidad. Los números nominales de prima de este primer trimestre (julio-septiembre) indican unos $6.000 millones de pesos argentinos, los cuales deberán recibir su ajuste por inflación para reflejar el número que finalmente informaremos las compañías a la SSN. Un indicador de actividad es la cantidad de pólizas, que ostentó 179.000 emisiones en este trimestre, dato que supera por un 14% al mismo periodo del ejercicio anterior, inmerso en una cuarentena que todavía trababa fuerte la actividad económica. Como tendencia menos alentadora, en el trimestre inmediatamente anterior (abril-junio) se emitió casi un 10% más de pólizas que en este trimestre, lo cual coincide con el inicio del ajuste y las restricciones en varios frentes de nuestra economía doméstica. Cuando hablamos de la variable siniestros, todo indica que hay una leve mayor incidencia de intensidad, con 209 pólizas siniestrados en este inicio de ejercicio, y 918 en la anualidad total 2021-2022. Se nos presenta una economía 2022 cuyo avance estará en el orden del 3%, y que parece enfriarse para lo que viene (2023) con pronósticos que anticipan épocas de vacas flacas para el negocio. Por el momento, el nuevo ejercicio parece no dar señales claras de lo que viene en el estratégico año electoral 2023. La imperiosa necesidad de ajuste, para darle un poco de orden a la macro, se verá contrastada con la urgencia electoral de mejorar el clima económico y social de una sociedad asfixiada por la galopante inflación, la más alta desde 1991. Afianzadora continuará ajustando sus pautas de suscripción con el fin de responder con responsabilidad a este escenario cambiante, donde el superávit técnico es una condición necesaria para hacer frente a este marco de inversiones con rendimientos negativos.",
        img: "/img/ImgPrensaPrueba.jpg",
        alt: "Graficos de finanzas"
    },
    {
        id: 2,
        date:"2/4/23",
        media: "El seguro en acción",
        publicationDate: "septiembre 2022",
        title: "Entrevista a Mariano Nimo, Gerente General de afianzadora",
        text: "Mariano Nimo analizó el impacto de la macroeconomía en la prima del seguro de Caución en la Argentina .Observó que los balances de las aseguradoras del ramo fueron positivos a marzo 2022 pero con menor rentabilidad que en el pasado. Las primas de Caución le ganaron a la inflación hasta marzo pero ahora estarían en un nivel inferior.Afirmó que faltan grandes obras de infraestructura que movilicen la prima, y se refirió al impacto del Gasoducto Néstor Kirchner, cuando su obra se ponga en marcha. También habló sobre las garantías aduaneras: sostuvo que en el primer semestre de Expo/Impo fue muy bueno. Pero en el segundo semestre el sector se está ralentizando.Alerta sobre las consecuencias de un achicamiento de la economía sobre el seguro de Caución.¿Cómo ampliar el mercado? Dijo que hay que difundir más el seguro de Caución incluso entre los PAS.La Escuela de Afianzadora está abierta a todos los profesionales del sector.",
        img: "/img/MarianoNimo.jpg",
        alt: "Graficos de finanzas"
    },
    {
        id: 3,
        date:"2/4/23",
        media: "El seguro en acción",
        publicationDate: "septiembre 2022",
        title: "Entrevista a Mariano Nimo, Gerente General de afianzadora",
        text: "Mariano Nimo analizó el impacto de la macroeconomía en la prima del seguro de Caución en la Argentina .Observó que los balances de las aseguradoras del ramo fueron positivos a marzo 2022 pero con menor rentabilidad que en el pasado. Las primas de Caución le ganaron a la inflación hasta marzo pero ahora estarían en un nivel inferior.Afirmó que faltan grandes obras de infraestructura que movilicen la prima, y se refirió al impacto del Gasoducto Néstor Kirchner, cuando su obra se ponga en marcha. También habló sobre las garantías aduaneras: sostuvo que en el primer semestre de Expo/Impo fue muy bueno. Pero en el segundo semestre el sector se está ralentizando.Alerta sobre las consecuencias de un achicamiento de la economía sobre el seguro de Caución.¿Cómo ampliar el mercado? Dijo que hay que difundir más el seguro de Caución incluso entre los PAS.La Escuela de Afianzadora está abierta a todos los profesionales del sector.",
        img: "/img/MarianoNimo.jpg",
        alt: "Graficos de finanzas"
    },
    {
        id: 4,
        date:"2/4/23",
        media: "Tiempo de seguros",
        publicationDate: "Octubre 2022",
        title: "Afianzadora: 1T. 2022-2023 en Seguros de Caución, ¿Avance, Arrastre o Recesión?",
        text: "Arrancó el ejercicio 2022-2023 en el nicho de las fianzas argentinas, con estimaciones que nos permiten avizorar que el avance del negocio sigue a buen ritmo, pero a menor velocidad. Los números nominales de prima de este primer trimestre (julio-septiembre) indican unos $6.000 millones de pesos argentinos, los cuales deberán recibir su ajuste por inflación para reflejar el número que finalmente informaremos las compañías a la SSN. Un indicador de actividad es la cantidad de pólizas, que ostentó 179.000 emisiones en este trimestre, dato que supera por un 14% al mismo periodo del ejercicio anterior, inmerso en una cuarentena que todavía trababa fuerte la actividad económica. Como tendencia menos alentadora, en el trimestre inmediatamente anterior (abril-junio) se emitió casi un 10% más de pólizas que en este trimestre, lo cual coincide con el inicio del ajuste y las restricciones en varios frentes de nuestra economía doméstica. Cuando hablamos de la variable siniestros, todo indica que hay una leve mayor incidencia de intensidad, con 209 pólizas siniestrados en este inicio de ejercicio, y 918 en la anualidad total 2021-2022. Se nos presenta una economía 2022 cuyo avance estará en el orden del 3%, y que parece enfriarse para lo que viene (2023) con pronósticos que anticipan épocas de vacas flacas para el negocio. Por el momento, el nuevo ejercicio parece no dar señales claras de lo que viene en el estratégico año electoral 2023. La imperiosa necesidad de ajuste, para darle un poco de orden a la macro, se verá contrastada con la urgencia electoral de mejorar el clima económico y social de una sociedad asfixiada por la galopante inflación, la más alta desde 1991. Afianzadora continuará ajustando sus pautas de suscripción con el fin de responder con responsabilidad a este escenario cambiante, donde el superávit técnico es una condición necesaria para hacer frente a este marco de inversiones con rendimientos negativos.",
        img: "/img/ImgPrensaPrueba.jpg",
        alt: "Graficos de finanzas"
    }
]}

const PrensaTable = () => {
    const fileName= 'Prensa'
  return (
    <div className="form-box-prensa">
     <Link to="/prensa"><button className="see-button">
            AGREGAR</button></Link>
    <div>
        <MDBDataTable
        striped
        bordered
        hover
        data={data} 
        />
        <ExportExcel apiData={data.rows} fileName={fileName}/>
   </div>
    </div>
  )
}

export default PrensaTable